export default {
  privacy: {
    badge: 'DATENSCHUTZ',
    title: 'Datenschutzerklärung',
    updated: 'Zuletzt aktualisiert: September 2026',
    sections: [
      {
        title: '1. Verantwortlicher für die Datenverarbeitung',
        blocks: [
          { type: 'p', text: 'Diese Datenschutzerklärung erläutert, wie Limpia Sàrl die personenbezogenen Daten der Besucher ihrer Website und ihrer Kunden verarbeitet.' },
          { type: 'p', text: 'Limpia Sàrl — Rte de Rosé 51, 1754 Avry-sur-Matran, Schweiz' },
          { type: 'p', text: 'IDE/USt-IdNr.: CHE-427.499.887' },
          { type: 'p', text: 'Bei Fragen zum Datenschutz können Sie uns über die auf unserer Website angegebene E-Mail-Adresse kontaktieren.' },
        ],
      },
      {
        title: '2. Erhobene personenbezogene Daten',
        blocks: [
          { type: 'p', text: 'Wenn Sie unsere Website nutzen, können wir personenbezogene Daten verarbeiten, die Sie uns freiwillig übermitteln, insbesondere wenn Sie:' },
          { type: 'li', text: 'uns per E-Mail kontaktieren;' },
          { type: 'li', text: 'unser Kontaktformular nutzen;' },
          { type: 'li', text: 'ein Angebot oder eine Offerte anfordern;' },
          { type: 'li', text: 'Informationen zu unseren Dienstleistungen anfordern;' },
          { type: 'li', text: 'im Rahmen einer Geschäftsbeziehung mit uns kommunizieren.' },
          { type: 'p', text: 'Je nach Art Ihrer Anfrage können die Daten insbesondere umfassen:' },
          { type: 'li', text: 'Vor- und Nachname;' },
          { type: 'li', text: 'E-Mail-Adresse;' },
          { type: 'li', text: 'Telefonnummer;' },
          { type: 'li', text: 'Postadresse;' },
          { type: 'li', text: 'Informationen zu Ihrer Anfrage;' },
          { type: 'li', text: 'alle weiteren Informationen, die Sie uns mitteilen möchten.' },
          { type: 'p', text: 'Wir können zudem bestimmte technische Daten verarbeiten, die beim Besuch der Website automatisch erzeugt werden, wie IP-Adresse, Browsertyp, Betriebssystem, Datum und Uhrzeit des Besuchs sowie die besuchten Seiten.' },
        ],
      },
      {
        title: '3. Zwecke der Verarbeitung',
        blocks: [
          { type: 'p', text: 'Wir verarbeiten personenbezogene Daten nur im erforderlichen Umfang, insbesondere um:' },
          { type: 'li', text: 'Ihre Anfragen zu beantworten;' },
          { type: 'li', text: 'Angebote oder Offerten zu erstellen und zu übermitteln;' },
          { type: 'li', text: 'unsere Leistungen zu erbringen;' },
          { type: 'li', text: 'unsere Beziehung zu Kunden und Partnern zu pflegen;' },
          { type: 'li', text: 'den Betrieb und die Sicherheit der Website zu gewährleisten;' },
          { type: 'li', text: 'unsere Dienstleistungen und unsere Online-Präsenz zu verbessern;' },
          { type: 'li', text: 'unseren gesetzlichen und behördlichen Verpflichtungen nachzukommen.' },
        ],
      },
      {
        title: '4. Kontaktformular',
        blocks: [
          { type: 'p', text: 'Wenn Sie das auf unserer Website verfügbare Kontaktformular nutzen, werden die eingegebenen Informationen an Limpia Sàrl übermittelt, damit wir Ihre Anfrage bearbeiten können.' },
          { type: 'p', text: 'Die über das Formular übermittelten Daten werden nicht ohne angemessene Rechtsgrundlage oder, soweit erforderlich, ohne Ihre Einwilligung für Werbezwecke verwendet.' },
          { type: 'p', text: 'Wir empfehlen, über das Formular keine sensiblen Informationen zu übermitteln, die für die Bearbeitung Ihrer Anfrage nicht erforderlich sind.' },
        ],
      },
      {
        title: '5. Weitergabe von Daten an Dritte',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl verkauft Ihre personenbezogenen Daten nicht.' },
          { type: 'p', text: 'Im Rahmen des Betriebs unserer Website und unserer Tätigkeiten können bestimmte Daten, soweit erforderlich, von externen Dienstleistern verarbeitet werden, zum Beispiel:' },
          { type: 'li', text: 'Hosting-Anbieter der Website;' },
          { type: 'li', text: 'E-Mail-Dienstleister;' },
          { type: 'li', text: 'technischer Dienstleister für die Wartung der Website;' },
          { type: 'li', text: 'Analyse- oder Statistik-Tools, sofern verwendet;' },
          { type: 'li', text: 'weitere für die Erbringung unserer Leistungen erforderliche Dienstleister.' },
          { type: 'p', text: 'Diese Dienstleister dürfen personenbezogene Daten ausschliesslich im Rahmen ihrer Leistungen und in Übereinstimmung mit den geltenden gesetzlichen Anforderungen verarbeiten.' },
          { type: 'p', text: 'Werden personenbezogene Daten in ein Land ausserhalb der Schweiz oder des Europäischen Wirtschaftsraums übermittelt, stellen wir sicher, dass die für diese Übermittlung geltenden rechtlichen Voraussetzungen eingehalten werden.' },
        ],
      },
      {
        title: '6. Cookies',
        blocks: [
          { type: 'p', text: 'Unsere Website kann Cookies und ähnliche Technologien verwenden, um ihren ordnungsgemässen Betrieb zu gewährleisten, die Nutzererfahrung zu verbessern und gegebenenfalls Besucherstatistiken zu erheben.' },
          { type: 'p', text: 'Cookies können es der Website insbesondere ermöglichen, bestimmte Präferenzen zu speichern oder bestimmte technische Funktionen zu gewährleisten.' },
          { type: 'p', text: 'Wenn Cookies oder Tracking-Technologien Ihre Einwilligung erfordern, wird diese gemäss den geltenden gesetzlichen Anforderungen eingeholt.' },
          { type: 'p', text: 'Sie können Ihren Browser zudem so konfigurieren, dass bestimmte Cookies eingeschränkt oder blockiert werden. Die Deaktivierung bestimmter Cookies kann jedoch die Funktion der Website beeinträchtigen.' },
        ],
      },
      {
        title: '7. Analyse-Tools und externe Dienste',
        blocks: [
          { type: 'p', text: 'Wenn Analyse-, Statistik-, Karten-, Video- oder andere externe Dienste in unsere Website eingebunden sind, können diese bestimmte technische Daten im Zusammenhang mit Ihrer Nutzung der Website verarbeiten.' },
          { type: 'p', text: 'Die tatsächlich auf der Website verwendeten Dienste sind in dieser Datenschutzerklärung und, soweit erforderlich, in unserem Cookie-Manager aufgeführt.' },
        ],
      },
      {
        title: '8. Aufbewahrungsdauer',
        blocks: [
          { type: 'p', text: 'Wir speichern personenbezogene Daten nur so lange, wie es zur Erfüllung der Zwecke, für die sie erhoben wurden, erforderlich ist.' },
          { type: 'p', text: 'Bestehen gesetzliche Aufbewahrungspflichten, können bestimmte Daten für die gesetzlich vorgeschriebene Dauer aufbewahrt werden.' },
          { type: 'p', text: 'Nach Ablauf dieser Frist werden die Daten gelöscht oder anonymisiert, soweit dies technisch möglich und rechtlich angemessen ist.' },
        ],
      },
      {
        title: '9. Datensicherheit',
        blocks: [
          { type: 'p', text: 'Wir setzen geeignete technische und organisatorische Massnahmen um, um personenbezogene Daten vor Verlust, Missbrauch, unbefugtem Zugriff, Veränderung oder Offenlegung zu schützen.' },
          { type: 'p', text: 'Allerdings kann keine Datenübertragung über das Internet und kein Computersystem absolute Sicherheit gewährleisten.' },
        ],
      },
      {
        title: '10. Ihre Rechte',
        blocks: [
          { type: 'p', text: 'Im Rahmen der geltenden Gesetzgebung haben Sie insbesondere das Recht:' },
          { type: 'li', text: 'Auskunft über die von uns über Sie verarbeiteten personenbezogenen Daten zu verlangen;' },
          { type: 'li', text: 'die Berichtigung unrichtiger personenbezogener Daten zu verlangen;' },
          { type: 'li', text: 'die Löschung Ihrer Daten zu verlangen, wenn die gesetzlichen Voraussetzungen erfüllt sind;' },
          { type: 'li', text: 'gegen bestimmte Verarbeitungen Ihrer Daten Widerspruch einzulegen;' },
          { type: 'li', text: 'soweit gesetzlich vorgesehen, die Herausgabe oder Übermittlung Ihrer Daten in einem geeigneten Format zu verlangen.' },
          { type: 'p', text: 'Zur Ausübung Ihrer Rechte oder zur Einholung von Informationen über die Verarbeitung Ihrer personenbezogenen Daten können Sie uns über die auf unserer Website angegebene E-Mail-Adresse kontaktieren.' },
        ],
      },
      {
        title: '11. Links zu Dritt-Websites',
        blocks: [
          { type: 'p', text: 'Unsere Website kann Links zu Websites enthalten, die von Dritten betrieben werden.' },
          { type: 'p', text: 'Limpia Sàrl ist nicht verantwortlich für den Inhalt, die Datenschutzpraktiken oder die Datenverarbeitung dieser Dritt-Websites.' },
          { type: 'p', text: 'Wir empfehlen, die Datenschutzerklärungen der betreffenden Websites zu lesen, bevor Sie ihnen personenbezogene Daten übermitteln.' },
        ],
      },
      {
        title: '12. Änderungen dieser Erklärung',
        blocks: [
          { type: 'p', text: 'Limpia Sàrl kann diese Datenschutzerklärung bei Bedarf ändern, insbesondere aufgrund rechtlicher, technischer oder organisatorischer Änderungen.' },
          { type: 'p', text: 'Die auf unserer Website veröffentlichte Fassung ist die gültige Fassung.' },
        ],
      },
      {
        title: '13. Kontakt',
        blocks: [
          { type: 'p', text: 'Bei Fragen zum Datenschutz oder zur Verwendung Ihrer personenbezogenen Daten wenden Sie sich bitte an:' },
          { type: 'p', text: 'Limpia Sàrl — Rte de Rosé 51, 1754 Avry-sur-Matran, Schweiz' },
          { type: 'p', text: 'E-Mail: info@limpiasarl.ch' },
        ],
      },
    ],
  },
};